import React from 'react';
import { Box, Flex, TextV2, ButtonV2 } from '@withjoy/joykit';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

export const UnpublishedWebsite: React.FC = () => {
  const { tq } = useTranslation('unpublishedWebsite');

  return (
    <Flex
      position="relative"
      minHeight="100vh"
      flexDirection="column"
      alignItems="center"
      paddingTop={pxToRem(160)}
      paddingX={[6, null, 10]}
      paddingBottom={pxToRem(160)}
      gap={pxToRem(140)}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        background="url('https://heygirl.cutestperson.com/assets/public/guest-side-under-construction.png')"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        opacity={0.4}
        zIndex="hide"
      />

      <Box
        position="absolute"
        top={[7, null, 10]}
        left={['50%', null, 10]}
        transform={['translateX(-50%)', null, 'unset']}
        zIndex={1}
      >
        <JoyLogo
          width={106}
          height={74}
        />
      </Box>

      <Flex
        flexDirection="column"
        alignItems="center"
        gap={10}
      >
        <Flex
          position="relative"
          paddingBottom="30%"
          width="100%"
          maxWidth={pxToRem(470)}
          overflow="hidden"
        >
          <Box
            top="50%"
            transform="translateY(-50%)"
            position="absolute"
            as="img"
            width="100%"
            src="https://heygirl.cutestperson.com/assets/public/guest-side-under-construction-welcome.gif"
            alt={tq`Welcome`}
          />
        </Flex>
        <Flex
          width="100%"
          maxWidth={pxToRem(370)}
          flexDirection="column"
          alignItems="center"
          gap={4}
        >
          <TextV2
            typographyVariant="hed6"
            color="mono14"
            textAlign="center"
          >
            {tq`This site is still in the works.`}
          </TextV2>

          <TextV2
            typographyVariant="body2"
            color="mono12"
            textAlign="center"
          >
            {tq`Exciting things are happening behind the scenes. The site is currently under construction and will be unveiled here shortly. Please check back soon for all the details.`}
          </TextV2>
        </Flex>
      </Flex>

      <Flex
        width="100%"
        maxWidth={pxToRem(370)}
        flexDirection="column"
        alignItems="center"
        gap={6}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          gap={4}
        >
          <TextV2
            typographyVariant="hed5"
            color="mono14"
            textAlign="center"
          >
            {tq`Planning your own event?`}
          </TextV2>
          <TextV2
            typographyVariant="body2"
            color="mono12"
            textAlign="center"
          >
            {tq`Create your own event website, invite guests and share all the details with Joy.`}
          </TextV2>
        </Flex>
        <ButtonV2
          size="lg"
          as="a"
          href="https://heygirl.cutestperson.com"
          target="_blank"
          rel="noopener noreferrer"
          variant="outline"
          shape="rounded"
          width="100%"
          maxWidth={pxToRem(240)}
          intent="neutral"
        >
          {tq`Learn More`}
        </ButtonV2>
      </Flex>
    </Flex>
  );
};
